var map = {
	"./aia.svg": 2994,
	"./ant.svg": 2995,
	"./aus.svg": 2996,
	"./bah.svg": 2997,
	"./ban.svg": 2998,
	"./bar.svg": 2999,
	"./ber.svg": 3000,
	"./biz.svg": 3001,
	"./bot.svg": 3002,
	"./bru.svg": 3003,
	"./can.svg": 3004,
	"./cay.svg": 3005,
	"./cmr.svg": 3006,
	"./cok.svg": 3007,
	"./cyp.svg": 3008,
	"./dma.svg": 3009,
	"./eng.svg": 3010,
	"./fij.svg": 3011,
	"./flk.svg": 3012,
	"./gab.svg": 3013,
	"./gam.svg": 3014,
	"./ggy.svg": 3015,
	"./gha.svg": 3016,
	"./gib.svg": 3017,
	"./grn.svg": 3018,
	"./guy.svg": 3019,
	"./ind.svg": 3020,
	"./iom.svg": 3021,
	"./ivb.svg": 3022,
	"./jam.svg": 3023,
	"./jey.svg": 3024,
	"./ken.svg": 3025,
	"./kir.svg": 3026,
	"./lca.svg": 3027,
	"./les.svg": 3028,
	"./manifest.json": 863,
	"./mas.svg": 3029,
	"./maw.svg": 3030,
	"./mdv.svg": 3031,
	"./mlt.svg": 3032,
	"./moz.svg": 3033,
	"./mri.svg": 3034,
	"./msr.svg": 3035,
	"./nam.svg": 3036,
	"./nfk.svg": 3037,
	"./ngr.svg": 3038,
	"./nir.svg": 3039,
	"./niu.svg": 3040,
	"./nru.svg": 3041,
	"./nzl.svg": 3042,
	"./pak.svg": 3043,
	"./png.svg": 3044,
	"./rsa.svg": 3045,
	"./rwa.svg": 3046,
	"./sam.svg": 3047,
	"./sco.svg": 3048,
	"./sey.svg": 3049,
	"./sgp.svg": 3050,
	"./shn.svg": 3051,
	"./skn.svg": 3052,
	"./sle.svg": 3053,
	"./sol.svg": 3054,
	"./sri.svg": 3055,
	"./svg-country.svg": 3056,
	"./swz.svg": 3057,
	"./tan.svg": 3058,
	"./tca.svg": 3059,
	"./tga.svg": 3060,
	"./tog.svg": 3061,
	"./tto.svg": 3062,
	"./tuv.svg": 3063,
	"./uga.svg": 3064,
	"./van.svg": 3065,
	"./wal.svg": 3066,
	"./zam.svg": 3067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2993;